export default __webpack_public_path__ + "downloadIcon.svg";